import { combineReducers } from 'redux'
import {
  VESSEL_TRACKING_ERROR,
  VESSEL_TRACKING_LOADING,
  VESSEL_TRACKING_SUCCESS,

  VESSEL_TRACKING_VIEW_ERROR,
  VESSEL_TRACKING_VIEW_LOADING,
  VESSEL_TRACKING_VIEW_SUCCESS
} from './constant'

const vesselTrackingError = (state = false, action) => {
  switch (action.type) {
    case VESSEL_TRACKING_ERROR:
      return action.vesselTrackingError
    default:
      return state
  }
}

const vesselTrackingLoading = (state = false, action) => {
  switch (action.type) {
    case VESSEL_TRACKING_LOADING:
      return action.vesselTrackingLoading
    default:
      return state
  }
}

const vesselTrackingSuccess = (state = false, action) => {
  switch (action.type) {
    case VESSEL_TRACKING_SUCCESS:
      return action.vesselTrackingSuccess
    default:
      return state
  }
}

const vesselTracking = (state = [], action) => {
  switch (action.type) {
    case VESSEL_TRACKING_SUCCESS:
      return action.vesselTracking
    default:
      return state
  }
}

const vesselTrackingViewError = (state = false, action) => {
  switch (action.type) {
    case VESSEL_TRACKING_VIEW_ERROR:
      return action.vesselTrackingViewError
    default:
      return state
  }
}

const vesselTrackingViewLoading = (state = false, action) => {
  switch (action.type) {
    case VESSEL_TRACKING_VIEW_LOADING:
      return action.vesselTrackingViewLoading
    default:
      return state
  }
}

const vesselTrackingViewSuccess = (state = false, action) => {
  switch (action.type) {
    case VESSEL_TRACKING_VIEW_SUCCESS:
      return action.vesselTrackingViewSuccess
    default:
      return state
  }
}

const vesselTrackingView = (state = [], action) => {
  switch (action.type) {
    case VESSEL_TRACKING_VIEW_SUCCESS:
      return action.vesselTrackingView
    default:
      return state
  }
}

const vesselTrackingReducer = combineReducers({
  vesselTrackingError,
  vesselTrackingLoading,
  vesselTrackingSuccess,
  vesselTracking,
  
  vesselTrackingViewError,
  vesselTrackingViewLoading,
  vesselTrackingViewSuccess,
  vesselTrackingView
})

export default vesselTrackingReducer
